import classNames from 'classnames'
import React from 'react'

import {aggressiveLazyLoad, defaultLazyLoad, LazyLoadMethodType} from '../lozad'
import useOnce from '../../../hooks/useOnce'

import '../../../../scss/components/_lazy-load.scss'

interface LazyLoadImageProps {
  alt: string
  src: string
  className?: string
  lazyLoadMethod?: LazyLoadMethodType
  srcSet?: string
}

const LazyLoadImage: React.FC<LazyLoadImageProps & React.HTMLAttributes<HTMLImageElement>> = ({
  alt,
  className,
  lazyLoadMethod,
  src,
  srcSet,
  ...props
}) => {
  useOnce(() => {
    // lazy load and observe dynamically added elements
    if (lazyLoadMethod === LazyLoadMethodType.aggressive) {
      aggressiveLazyLoad.observe()
    } else {
      defaultLazyLoad.observe()
    }
  })
  const imageClasses = classNames('lozad', 'c-lazy-img', className)

  return <img alt={alt} className={imageClasses} data-src={src} data-srcset={srcSet} {...props} />
}

LazyLoadImage.defaultProps = {
  lazyLoadMethod: LazyLoadMethodType.default,
}

export default LazyLoadImage
